import { createVNode as a, mergeProps as n } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileHtmlTwotoneStandard.js";
import m from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(m, n(e, {
    icon: l
  }), null);
};
t.displayName = "FileHtmlTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
